<template>
  <div>
    <!--搜索-->
    <div class="box study_top">
      <div class="wrap w1200 search">
        <dl>
          <dt>首页 - 直播 - 直播列表</dt>
          <dd><input v-model="filter.courseOrTeacherName" type="text" class="put_txt paddingR_0" placeholder="搜索直播(请输入直播名称)" @keyup.13="searchByFilter(null, null, filter.courseOrTeacherName, null)" /><input type="button" class="put_btn" value="搜 索" @click="searchByFilter(null, null, filter.name, null)"/>
          </dd>
        </dl>
      </div>
    </div>
    <!--/搜索-->
    <!--筛选-->
    <div class="wrap w1200 study_cat">
      <dl>
        <dt>按分类：</dt>
        <dd><a href="javascript:;" @click="searchByFilter('', null, null, $event)">全部</a><a href="javascript:;" v-for="item in trees" :key="item.id" @click="searchByFilter(item.id, null, null, $event)">{{item.name}}</a><!--<a href="javascript:;" class="focus">员工培训</a>--></dd>
      </dl>
      <div class="clear"></div>
      <dl class="mt25">
        <dt>讲师：</dt>
        <dd><a href="javascript:;" @click="searchByFilter(null, '', null, $event)">全部</a><a href="javascript:;" v-for="item in teacherList" :key="item.id" @click="searchByFilter(null, item.id, null, $event)">{{item.name}}</a></dd>
      </dl>
    </div>
    <!--/筛选-->
    <!--课件列表-->
    <div class="box livePlay_list">
      <div class="wrap w1200">
        <div class="top_tit">
          <h3>直播课程</h3>
          <a href="javascript:;" class="study_prv" title="上一页" @click="page_click('prev')"></a>
          <a href="javascript:;" class="study_next" title="下一页" @click="page_click('next')"></a>
        </div>
        <div class="list livePlayList">
          <a href="javascript:;" v-for="item in livePlayList" :key="item.id" @click="livePlay_detail(item.id)">
            <dl>
              <dt>
                <img v-if="item.cover" :src="item.cover" :title="item.title" />
                <img v-if="!item.cover || item.cover==''" src="@/assets/images/live_img.jpg" :title="item.title" />
                <span class="price_r" v-if="item.cost && item.cost != '0'">￥{{item.cost}}</span>
                <span class="price_r" v-if="!item.cost || item.cost == '0'">免费</span>
                <span class="play_con"></span>
                <span class="man_num_r">{{item.livePersonCnt}}</span>
                <span class="play_ing" v-if="item.timeStateName=='进行中'">正在直播{{$utils.substring(item.startTime,10,16)}}-{{$utils.substring(item.endTime,10,16)}}</span>
                <span class="play_end" v-if="item.timeStateName=='已结束'">直播结束</span>
                <span class="play_w_time" v-if="item.timeStateName=='未开始'">{{$utils.substring(item.startTime,0,16)}}-{{$utils.substring(item.endTime,0,16)}}</span>
                <span class="play_none" v-if="item.timeStateName=='未开始'">未开始</span>

                <span class="play_go" v-if="item.timeStateName=='进行中'" @click="viewLivePlay()">观看直播</span>
                <span class="play_go" v-if="item.timeStateName=='已结束'" @click="viewVideo()">观看视频</span>
              </dt>
              <dd>
                <h3>{{item.title}}</h3>
                <p v-if="item.livePlayTeacherList && item.livePlayTeacherList.length>0">讲师：{{item.livePlayTeacherList[0].teacherName}}<span v-if="item.livePlayTeacherList.length>1">等</span></p>
                <p v-if="!item.livePlayTeacherList">讲师：暂无</p>
              </dd>
            </dl>
          </a>
        </div>
      </div>
    </div>
    <!--/课件列表-->
  </div>
</template>
<script>

export default {
  components: { },
  data () {
    return {
      filter: {
        pageNo: 1,
        pageSize: 12,
        state: '1',
        name: '',
        teacherIds: []
      },
      trees: [],
      teacherList: [],
      livePlayList: [],
      currentPage: 1,
      pages: 0,
      livePlayCnt: 0
    }
  },
  created () {
    this.getLivePlays(this.filter)
    this.getTeachers()
  },
  mounted () {
    this.$nextTick(() => {
    })
  },
  computed: {},
  methods: {
    page_click (type) {
      if (type=='prev') {
        if (this.currentPage > 1) {
          this.filter.pageNo = this.currentPage - 1
          this.currentPage--
          this.getLivePlays(this.filter)
        }
      } else if (type=='next') {
        if (this.currentPage < this.pages) {
          this.filter.pageNo = this.currentPage + 1
          this.currentPage++
          this.getLivePlays(this.filter)
        }
      }
    },
    searchByFilter (classificationId, teacherId, name, event) {
      this.currentPage = 1
      this.filter.pageNo = 1
      if (event != null) {
        $(event.target).siblings('a').removeClass("focus")
        $(event.target).addClass('focus')
      }
      if (classificationId != null) {
        this.filter.courseClassifiId = classificationId
      }
      if (teacherId != null) {
        this.filter.teacherIds = []
        if (teacherId != '') {
          this.filter.teacherIds.push(teacherId)
        }
      }
      if (name != null) {
        this.filter.name = name
      }
      this.getLivePlays(this.filter)
    },
    getLivePlays (filter) {
      this.$api.post(this.$global.livePlayApiPath, '/livePlayInfo/findList', filter, r => {
        if (r.data && r.data.length>0) {
          this.livePlayList = r.data
        } else {
          this.livePlayList = r.data
        }
        this.pages = Math.ceil(r.cntData / this.filter.pageSize)
      })
    },
    getTeachers () {
      this.$api.post(this.$global.teacherApiPath, '/teacher/teachers', {delFlag: '0'}, r => {
        if (r.data && r.data.length>0) {
          this.teacherList = r.data
        }
      })
    },
    livePlay_detail (id) {
      this.$router.push({path: '/byl/livePlayDetail/'+ id})
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/modules/livePlay/list.vue